export default __webpack_public_path__ + "assets/images/Invoice-1f1d8d48ff46a4ae270894348a178159.svg";